import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
@Component({
	selector: 'app-image-viewer',
	templateUrl: './image-viewer.component.html',
	styleUrls: ['./image-viewer.component.scss'],
	standalone: true,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImageViewerComponent
{
	@Input() imgSources: string[];
	@Input() imgTitle: string;
	@Input() imgDescription: string;
	@Input() allowEdit: boolean = false;

	slideOpts = {
		centeredSlides: true,
		lazy: true,
		zoom: {
			toggle: true
		}
	};

	constructor(private modalController: ModalController) { }

	ngOnInit()
	{
	}

	closeModal(action: string)
	{
		this.modalController.dismiss(
			{
				action: action
			}
		);
	}

	currentScale: number = 1;

	touchStartX: number;
	touchStartY: number;
	//turn dark mode on when we pinch to zoom
	async touchStartEvent(ev: any) 
	{
		this.touchStartY = ev.detail.changedTouches[0].clientY;
		this.touchStartX = ev.detail.changedTouches[0].clientX;
		this.currentScale = ev.target.swiper.zoom.currentScale;
		// console.log("Touch start", ev);
	}

	//turn dark mode on when we pinch to zoom
	async touchEndEvent(ev: any) 
	{
		// console.log("Touch end", ev);


		//if zoom scale has changed, we must have pinched
		var zoomScale = ev.target.swiper.zoom.currentScale;
		if (this.currentScale != zoomScale)
		{
			this.currentScale = zoomScale;
		}
		else if (zoomScale == 1)
		{
			//see if we have a swipe down/up
			var diffY = ev.detail.changedTouches[0].clientY - this.touchStartY;
			var diffX = ev.detail.changedTouches[0].clientX - this.touchStartX;
			if ((diffY < -150 || diffY > 150) && (diffX > -50 && diffX < 50))
			{
				this.closeModal('swipe-down');
			}

		}
	}
	scrollTop: boolean = true;
	ionScrollEvent(ev: any)
	{
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop != scrollTop)
		{
			this.scrollTop = scrollTop;
		}
	}
}